/* Campaign links into a chosen bundle.

   An ad can point at a specific offer:
     /pages/bundles?bundle=2-for-30
     /pages/bundles?bundle=3-for-55
   and the page opens on that tier. The tabs still work, so the shopper can
   move to another offer — the link chooses the starting point, it does not
   lock anything.

   Accepted forms, all case-insensitive:
     the label slug   2-for-30, 3for55, "2 for 40"
     the amount alone 30, 40, 55, 60, 85
     the internal key twoS, two, three, twoP, threeP
   Anything unrecognised is ignored and the page opens normally, because an
   ad link with a typo should still land somewhere sensible.

   This runs before the builder starts, so only the chosen range is fetched
   — setting it afterwards would load the default range first and throw it
   away, costing the shopper a needless round trip on a paid click.

   The tab the shopper lands on is written back into the address bar, so a
   shared or bookmarked link keeps the offer. */
(function(){
"use strict";
function slug(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') }

function resolve(bundles, want){
  if(!want) return null;
  var w=slug(want), keys=Object.keys(bundles||{}), i, k, b, s;
  /* internal key, exactly as written in the catalogue */
  for(i=0;i<keys.length;i++) if(slug(keys[i])===w) return keys[i];
  /* label slug: "2 for 30 KD" matches 2-for-30 and 2-for-30-kd */
  for(i=0;i<keys.length;i++){
    k=keys[i]; b=bundles[k]; s=slug(b.label);
    if(s===w || s===w+'-kd' || s.replace(/-kd$/,'')===w) return k;
  }
  /* bare amount: 30, 55, 85 */
  if(/^[0-9]+$/.test(w)){
    for(i=0;i<keys.length;i++){
      k=keys[i]; b=bundles[k];
      if(String(b.label).replace(/[^0-9]/g,'').indexOf(w)>-1 && String(Math.round(b.price/1000))===w) return k;
    }
  }
  return null;
}

function wanted(){
  var q; try{ q=new URLSearchParams(window.location.search) }catch(e){ return null }
  return q.get('bundle') || q.get('offer') || q.get('tier');
}

document.addEventListener('DOMContentLoaded', function(){
  var grid=document.getElementById('bGrid');
  if(!grid || !window.SF) return;
  var data={}; try{ data=JSON.parse((document.getElementById('sf-data')||{}).textContent||'{}') }catch(e){}
  var key=resolve(data.bundles, wanted());
  if(key && typeof SF.setTier==='function') SF.setTier(key);

  /* Keep the address bar honest as the shopper switches tabs. */
  if(typeof SF.setTier==='function' && window.history && history.replaceState){
    var orig=SF.setTier;
    SF.setTier=function(k){
      orig(k);
      var b=(data.bundles||{})[k];
      if(!b) return;
      try{
        var u=new URL(window.location.href);
        u.searchParams.set('bundle', slug(b.label).replace(/-kd$/,''));
        history.replaceState({}, '', u.toString());
      }catch(e){}
    };
  }
});
})();